import { isValidElement } from 'react';
import { isEmpty } from '../../../helpers';
const ACCESSIBILITY_LABEL_ERROR = '[Multiselect - Accessibility Error] O elemento select deve ter um label associado. Informe pelo menos um dos atributos "label" | "aria-label" | "aria-labelledby" com valor válido.';
const ACCESSIBILITY_LOADING_ERROR = '[Multiselect - Accessibility Error] Quando o state for "loading" é obrigatório informar um "stateMessage" para indicar para os leitores de tela a mensagem de carregamento.';
const LABEL_WITHOUT_ID_ERROR = '[Multiselect - Error] Para utilização da label no componente é obrigatório a utilização de um id válido.';
export const validateAccessibilityProps = _ref => {
  let {
    ariaLabel,
    ariaLabelledBy,
    label,
    state,
    stateMessage
  } = _ref;
  if (!isValidElement(label) && typeof label === 'string' && isEmpty(label) && isEmpty(ariaLabel) && isEmpty(ariaLabelledBy)) {
    throw new Error(ACCESSIBILITY_LABEL_ERROR);
  }
  if (state === 'loading' && isEmpty(stateMessage)) throw new Error(ACCESSIBILITY_LOADING_ERROR);
};
export const validateLabelAndIdProps = _ref2 => {
  let {
    id,
    label
  } = _ref2;
  if (!isValidElement(label) && typeof label === 'string' && isEmpty(id)) throw new Error(LABEL_WITHOUT_ID_ERROR);
};